import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const Fax = (props) => {
  return (
    <FormGroup controlId="fax">
      <Col componentClass={ControlLabel} sm={5}>
        Fax
      </Col>
    <Col sm={7}>
        <FormControl type="text" value={props.fax} onChange={props.handleChangeFax}
          autoComplete="off" />
    </Col>
    </FormGroup>
  )
}

Fax.propTypes = {
  fax: PropTypes.string,
  handleChangeFax: PropTypes.func
};

export default Fax;



// WEBPACK FOOTER //
// ./src/app/components/fax/Fax.js